const controller = () => {

};

export default controller;



// WEBPACK FOOTER //
// ./src/modules/side-menu/components/html/html.controller.js